import type { ComponentProps } from 'react';
import { ReviewsCarousel } from '@fiverr-private/reviews';
import pathfinder from '@fiverr-private/pathfinder';
import { getContext } from '@fiverr-private/fiverr_context';
import type { ReviewAttributes } from '@fiverr-private/gig_page_types';
import { PAGE_NAME } from '../../../constants';

interface GetReviewCarouselArgs {
    reviewAttributes: ReviewAttributes;
}

export const getReviewCarouselProps = ({
    reviewAttributes,
}: GetReviewCarouselArgs): ComponentProps<typeof ReviewsCarousel> => {
    const { pageCtxId } = getContext();
    const translationUrl = pathfinder('gig_page_translate_ugc_api');
    const { reviewSnippets } = reviewAttributes;

    return {
        initialState: {
            ...reviewAttributes,
            reviews: reviewSnippets,
            pageCtxId,
            pageName: PAGE_NAME,
        },
        translationUrl,
    };
};
